module.exports = __webpack_public_path__ + "static/media/AB_K17_3.ced68fa5.jpg";